module.exports = __webpack_public_path__ + "img/import_contacts.f283fee0.svg";